import { HttpHeaders } from '@angular/common/http';
export const HTTP_KEYCLAOK_CLIENT_HEADERS = new HttpHeaders().set('Accept', 'application/json');